import { render, staticRenderFns } from "./FileTypeIcon.vue?vue&type=template&id=ae033344"
import script from "./FileTypeIcon.vue?vue&type=script&lang=js"
export * from "./FileTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports